import React from 'react';
import useFetch from "../hooks/useFetch";
import {motion} from "framer-motion";
import {Discuss} from "react-loader-spinner";
import pomegranates_image from "../images/pomegranates_image.png";
import pomegranates_hero_image from "../images/pomegranates_hero_image.png";
import MenuItem from "../components/MenuItem";
import Navigator from "../components/Navigator";

const APIUrl = 'https://docs.google.com/spreadsheets/d/e/2PACX-1vR6U9b_4-849h_FAkj9XuRr6wKIthf5dKnc2tffjjvUXDq8sIyQWkHcGLG4vbBPK60ZtlLGPCSJ_uwS/pub?gid=0&single=true&output=tsv';

const Drinks = () => {
    const [data, isFetching] = useFetch(APIUrl);

    return (
        <motion.div
            exit={{
                opacity: 0
            }}
            className="mx-auto bg-[#D9D9D9] w-full relative">
            {isFetching && <Discuss colors={['#fa646e', '#fd2c3f']} wrapperClass={'bg-white flex w-screen h-screen items-center justify-center absolute top-0 left-0 z-20'}/>}

            <Navigator
                isDrinks={false}
            />

            <img src={pomegranates_image} className="w-full" alt="Separator image"/>

            <img src={pomegranates_hero_image} className="mt-10 mx-auto" alt="Separator image"/>

            <h1 className={'mb-7 mx-auto w-fit text-[#DE0034] text-5xl font-bolder text-center'}>МЕНЮ</h1>

            {
                data.map((row, index) => <MenuItem key={index} {...row}/>)
            }

            <img src={pomegranates_image} className="w-full mt-10" alt="Separator image"/>
        </motion.div>
    );
};

export default Drinks;